import React from 'react';
import { Modal, Button } from '@praktio/common-ui';

import './NetworkErrorModal.scss';

interface IProps {
  show: boolean;
  onHide: () => void;
  submitFeedback: () => void;
}

const NetworkErrorModal = ({ show, onHide, submitFeedback }: IProps) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      onSave={onHide}
      title="Network Error"
      description="An error has occured. Refresh the page, or contact us."
      saveText="OK"
      className="NeworkErrorModal"
      footerAdditions={<Button onClick={() => submitFeedback()}>Report</Button>}
    ></Modal>
  );
};

export default NetworkErrorModal;
